import { z } from 'zod'

export const FlagModule = z.enum([
  'FOOD',
  'BATHROOM',
  'MEDICINES',
  'LIQUIDS',
  'BELONGINGS',
  'SLEEP',
  'LESION',
  'CAA',
  'PHOTO'
])
export type FlagModule = z.infer<typeof FlagModule>
